import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { fbTrack } from "@/lib/fb-pixel";

/**
 * Wires Meta Pixel events for the whole app:
 *  - PageView on route change
 *  - ViewContent when visiting /masterclass
 *  - Lead on any click of a Calendly link or in-page #book anchor
 *  - Contact on any click of a m.me Messenger link
 */
export default function AppTracking() {
  const location = useLocation();

  // Route-change PageView + ViewContent for masterclass
  useEffect(() => {
    fbTrack("PageView");
    if (location.pathname === "/masterclass") {
      fbTrack("ViewContent", {
        content_name: "NLV Masterclass",
        content_category: "masterclass",
      });
    }
  }, [location.pathname]);

  // Global click delegation for CTAs
  useEffect(() => {
    const handler = (e) => {
      const a = e.target.closest && e.target.closest("a, button");
      if (!a) return;
      const href = a.getAttribute && a.getAttribute("href");
      if (!href) return;

      if (href.includes("calendly.com") || href.endsWith("#book") || href === "#book") {
        fbTrack("Lead", {
          content_name: "Book a call",
          source: location.pathname,
        });
      } else if (href.includes("m.me/") || href.includes("messenger.com")) {
        fbTrack("Contact", {
          content_name: "Message on Facebook",
          source: location.pathname,
        });
      }
    };
    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, [location.pathname]);

  return null;
}
